<template>
  <div class="por-tienda d-flex flex-column flex-grow-1">
    <div class="d-flex flex-column gap-2 p-3">
      <!-- FILA SUPERIOR: Selector de Tienda y Búsqueda por IDs -->
      <div class="row no-gutters w-100 align-items-center p-2" style="margin: -0.25rem;">
        <div class="col-12 col-md-4 p-1">
          <select
            v-model="tiendaId"
            class="form-control form-control-md rounded w-100"
            @change="onTiendaCambia"
          >
            <option value="">Seleccione tienda...</option>
            <option v-for="t in tiendas" :key="t.codigo" :value="t.codigo">
              {{ t.codigo }} {{ t.nombre }}
            </option>
          </select>
        </div>
        <div v-if="tiendaId" class="col-12 col-md-8 p-1">
          <multiselect
            v-model="productosSeleccionados"
            tag-placeholder="Presiona Enter para agregar el ID"
            placeholder="Escribir IDs y presionar Enter..."
            :options="[]"
            :multiple="true"
            :taggable="true"
            @tag="addProductoId"
            @input="onProductosInCambia"
          >
            <template slot="noResult">No hay opciones disponibles. Escribe un ID y presiona Enter.</template>
          </multiselect>
        </div>
      </div>

      <!-- FILA INFERIOR: Selectores de Filtros (ABC, Estado, Categoría, Subcategoría) -->
      <div v-if="tiendaId" class="row no-gutters w-100 align-items-end p-2" style="margin: -0.25rem;">
        <div class="col-6 col-sm-3 col-md-auto p-1">
          <div class="position-relative">
            <label
              for="filtro-estado"
              class="position-absolute bg-light px-1 mb-0 small text-muted"
              style="top:-0.4rem; left:0.5rem; line-height:1; z-index:2"
            >Activo</label>
            <select
              id="filtro-estado"
              v-model="filtroEstado"
              class="form-control form-control-sm rounded bright w-100"
              @change="onFiltroEstadoCambia"
            >
              <option v-for="f in filtrosEstado" :key="f.valor" :value="f.valor">{{ f.label }}</option>
            </select>
          </div>
        </div>
        <div class="col-6 col-sm-3 col-md-auto p-1">
          <div class="position-relative">
            <label
              for="filtro-abc"
              class="position-absolute bg-light px-1 mb-0 small text-muted"
              style="top:-0.4rem; left:0.5rem; line-height:1; z-index:2"
            >ABC</label>
            <select
              id="filtro-abc"
              v-model="filtroabc"
              class="form-control form-control-sm rounded bright w-100"
              @change="onFiltroabcCambia"
            >
              <option v-for="f in filtrosabc" :key="f.valor" :value="f.valor">{{ f.label }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-auto p-1">
          <div class="position-relative">
            <label
              for="filtro-categoria"
              class="position-absolute bg-light px-1 mb-0 small text-muted"
              style="top:-0.4rem; left:0.5rem; line-height:1; z-index:2"
            >Categoría</label>
            <select
              id="filtro-categoria"
              v-model="categoriaId"
              class="form-control form-control-sm rounded bright w-100"
              :disabled="cargandoCategorias"
              @change="onCategoriaCambia"
            >
              <option value="">Todas</option>
              <option v-for="c in categorias" :key="c.codigo" :value="c.codigo">{{ c.nombre }}</option>
            </select>
          </div>
        </div>

        <div v-if="categoriaId !== ''" class="col-10 col-sm-5 col-md-auto p-1">
          <div class="position-relative">
            <label
              for="filtro-subcategoria"
              class="position-absolute bg-light px-1 mb-0 small text-muted"
              style="top:-0.4rem; left:0.5rem; line-height:1; z-index:2"
            >Subcategoría</label>
            <select
              id="filtro-subcategoria"
              v-model="subcategoriaId"
              class="form-control form-control-sm rounded bright w-100"
              :disabled="cargandoSubcategorias"
              @change="onSubcategoriaCambia"
            >
              <option value="">Todas</option>
              <option v-for="s in subcategorias" :key="s.codigo" :value="s.codigo">{{ s.nombre }}</option>
            </select>
          </div>
        </div>

        <div v-if="cargandoSubcategorias" class="col-auto p-1">
          <small class="text-muted"><i class="fas fa-spinner fa-spin"></i></small>
        </div>

        <div v-if="categoriaId !== ''" class="col-2 col-sm-1 col-md-auto p-1">
          <button
            class="btn btn-sm btn-outline-secondary w-100"
            @click="limpiarFiltroCategoria"
            title="Limpiar filtro de categoría"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="!tiendaId"
      class="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-muted p-4"
      >
      <i class="fas fa-store fa-3x mb-3" style="opacity:0.2"></i>
      <p class="mb-0">Selecciona una tienda para ver sus productos configurados</p>
    </div>
    <div
      v-if="tiendaId && cargando"
      class="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-muted"
      >
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="sr-only">Cargando...</span>
      </div>
      <p class="mb-0">Cargando productos...</p>
    </div>
    <div v-if="tiendaId && !cargando" class="flex-grow-1 p-2 d-flex flex-column">
      <div class="d-flex flex-wrap justify-content-between align-items-center m-2" style="gap: 8px" >
        <div class="text-muted">
        <strong>{{ totalRegistros }}</strong>
        {{ totalRegistros === 1 ? 'registro encontrado' : 'registros encontrados' }}
        </div>
        <div class="d-flex" style="gap: 8px">
          <button
            class="btn btn-outline-secondary btn-sm"
            :disabled="guardando || editedCount === 0"
            @click="$refs.configTable.descartarTodosLosCambios()"
          >
            <i class="fas fa-undo mr-1"></i>
            Descartar
          </button>
          <button
            class="btn btn-success btn-sm"
            :disabled="guardando || editedCount === 0"
            @click="guardarCambios"
          >
            <span v-if="guardando" class="spinner-border spinner-border-sm mr-1" role="status"></span>
            <i v-else class="fas fa-save mr-1"></i>
            {{ guardando ? 'Guardando...' : `Guardar ${editedCount} cambio${editedCount > 1 ? 's' : ''}` }}
          </button>
      </div>
      </div>

      <ProductoTiendaConfigTable
        ref="configTable"
        :configuraciones_producto_tienda="config_productos_en_tienda"
        :allowed-units-fn="getAllowedUnitsForProduct"
        max-height="75vh"
        @edited-count-change="editedCount = $event"
      >
        <template #columns-start>
          <th scope="col" class="align-top" style="min-width:180px">Producto</th>
        </template>
        
        <template #cells-start="{ item }">
          <td class="align-middle" style="max-width:280px">
            <div class="d-flex align-items-center text-nowrap">
              <span class="h6">{{ item.producto }}</span>
              <span v-if="!item.activo && !item.deshabilitado" class="badge badge-danger ml-1 text-nowrap">inactivo</span>
            </div>
            <div class="text-truncate font-weight-500" :title="item.producto_nombre" style="max-width:100%">
              {{ item.producto_nombre }}
            </div>
            <small v-if="item.errorInactivacion && !item.activo" class="d-block text-danger font-weight-bold" :title="item.errorInactivacion">{{ item.errorInactivacion }}</small>
          </td>
        </template>

        <template #columns-middle>
          <th scope="col" class="text-center align-middle" style="width:60px">abc</th>
        </template>

        <template #cells-middle="{ item }">
          <td class="text-center align-middle">
            <span class="badge badge-light border">{{ item.abc || '—' }}</span>
          </td>
        </template>
      </ProductoTiendaConfigTable>
    </div>
    <div
      v-if="tiendaId && !cargando && totalPaginas > 1"
      class="px-3 py-2 border-top d-flex justify-content-between align-items-center"
    >
      <nav>
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <button class="page-link" @click="irAPagina(paginaActual - 1)">
              <i class="fas fa-chevron-left"></i>
            </button>
          </li>
          <template v-for="p in paginasVisibles">
            <li v-if="p === '...'" :key="'sep-' + p" class="page-item disabled">
              <span class="page-link">…</span>
            </li>
            <li
              v-else
              :key="p"
              class="page-item"
              :class="{ active: paginaActual === p }"
            >
              <button class="page-link" @click="irAPagina(p)">{{ p }}</button>
            </li>
          </template>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
            <button class="page-link" @click="irAPagina(paginaActual + 1)">
              <i class="fas fa-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
    <div class="bg-warning border p-4 rounded mt-4" v-if="tiendaId && !cargando">
      <small class="font-weight-bold"
      >Tomar en cuenta lo siguiente:
        <br>
        <i class="fas fa-info-circle"></i>
          Cualquier modificación realizada en la configuración esta bajo
          su propia responsabilidad.
        <br />
        <i class="fas fa-info-circle"></i>
          Recuerde no modificar datos que no correspondan a su tienda de
          trabajo, cualquier modificación realizada quedara registrada
          con su información usuario.
      </small>
    </div>
  </div>
</template>
<script>
import DynamicService from '@/services/commons/DynamicService'
import Notifications from '@/notifications/notifications'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import ProductoTiendaConfigTable from './ProductoTiendaConfigTable.vue'

const PAGE_SIZE = 20
export default {
  name: 'ProductoTiendaConfigByTiendaComponent',
  components: { Multiselect, ProductoTiendaConfigTable },
  data() {
    return {
      tiendas: [],
      tiendaId: '',
      allowedUnitsBySku: {},
      productosSeleccionados: [],
      editedCount: 0,

      // Productos paginados
      config_productos_en_tienda: [],
      totalRegistros: null,
      paginaActual: 1,
      cargando: false,
      guardando: false,

      // Variables para filtros
      filtrosabc: [
        { valor: '', label: 'Todos' },
      ],

      filtrosEstado: [
        { valor: '', label: 'Todos' },
      ],

      // Variables para Filtros categoría / subcategoría
      categorias: [],
      subcategorias: [],
      categoriaId: '',
      subcategoriaId: '',
      cargandoCategorias: false,
      cargandoSubcategorias: false,
      filtroEstado: '',
       totalRegistros: null,
    }
  },

  computed: {
    tiendaActual() {
      return this.tiendas.find(t => t.id === this.tiendaId) || null
    },

    totalPaginas() {
      if (!this.totalRegistros) return 1
      return Math.ceil(this.totalRegistros / PAGE_SIZE)
    },
    paginasVisibles() {
      const total   = this.totalPaginas
      const current = this.paginaActual
      const delta   = 2
      const pages   = []

      for (let i = 1; i <= total; i++) {
        if (
          i === 1 ||
          i === total ||
          (i >= current - delta && i <= current + delta)
        ) {
          pages.push(i)
        } else if (
          pages[pages.length - 1] !== '...'
        ) {
          pages.push('...')
        }
      }
      return pages
    },
    totalPaginas() {
      if (!this.totalRegistros) return 1
      return Math.ceil(this.totalRegistros / PAGE_SIZE)
    },

  },

  created() {
    this.cargarTiendas()
    this.cargarCategorias()
  },


  methods: {
    async cargarTiendas() {
      try {
        const { data } = await DynamicService.fetch(
          'cat', 'tiendas', { quitar_paginacion: true }
        )
        this.tiendas = data || []
      } catch {
        Notifications.alert.error('Error', 'No se pudieron cargar las tiendas.')
      }
    },

    async cargarProductos() {
      if (!this.tiendaId) return
      this.cargando = true

      const params = {
        tienda: this.tiendaId,
        page:   this.paginaActual,
      }
      if (this.filtroabc !== '') params.abc = this.filtroabc
      
      if (this.filtroEstado === 'activo') {
        params.activo = true
        } else if (this.filtroEstado === 'inactivo') {
        params.activo = false
        }

      if (this.categoriaId    !== '') params['producto__categoria']    = this.categoriaId
      if (this.subcategoriaId !== '') params['producto__sub_categoria'] = this.subcategoriaId

      if (this.productosSeleccionados && this.productosSeleccionados.length > 0) {
        params['producto__in'] = this.productosSeleccionados.join(',')
      }

      try {
        const { data } = await DynamicService.fetch('cat', 'producto-tienda', params)
        const items = data && data.results || []
        
        // Asignar snapshots a los productos para trackear la edición
        this.config_productos_en_tienda = items.map(p => ({
          ...p,
          originalValue: { ...p }
        }))
        this.totalRegistros = data && data.count || 0

        this._actualizarFiltrosDesdeProductos(this.config_productos_en_tienda)
        await this.cargarUnidadesEnLote()
      } catch {
        Notifications.alert.error('Error', 'No se pudieron cargar los productos.')
        this.config_productos_en_tienda = []
        this.totalRegistros = 0
      } finally {
        this.cargando = false
      }
    },

    async cargarUnidadesEnLote() {
      const skus = Array.from(new Set(this.config_productos_en_tienda.map(p => p.producto_sku || p.producto)))
      if (skus.length === 0) return

      try {
        const { data } = await DynamicService.fetch(
          'cat', 'producto-unidad_medida',
          { producto__in: skus.join(','), limit: 1000 }
        )
        const units = data && data.results || []
        
        // Se agrupa unidades por sku
        const unitsMap = {}
        skus.forEach(s => { unitsMap[s] = [] })
        units.forEach(u => {
          if (unitsMap[u.producto]) {
            unitsMap[u.producto].push(u)
          }
        })
        this.allowedUnitsBySku = unitsMap
      } catch {
        this.allowedUnitsBySku = {}
      }
    },

    getAllowedUnitsForProduct(p) {
      const sku = p.producto_sku || p.producto
      return this.allowedUnitsBySku[sku] || []
    },

    // ── EVENTOS DE FILTROS ────────────────────────────────────
    onTiendaCambia() {
      this.paginaActual   = 1
      this.totalRegistros = null
      this.config_productos_en_tienda = []
      this.filtroabc      = ''
      this.filtroEstado   = ''
      this.filtrosabc     = [{ valor: '', label: 'Todos' }]
      this.filtrosEstado  = [{ valor: '', label: 'Todos' }]
      this.categoriaId    = ''
      this.subcategoriaId = ''
      this.subcategorias  = []
      this.productosSeleccionados = []
      this.cargarProductos()
    },

    onFiltroabcCambia() {
      this.paginaActual = 1
      this.cargarProductos()
    },
    onFiltroEstadoCambia() {
      this.paginaActual = 1
      this.cargarProductos()
    },

    // ── FILTROS MULTIPLES (IDs) ───────────────────────────────
    addProductoId(newTag) {
      if (!this.productosSeleccionados.includes(newTag)) {
        this.productosSeleccionados.push(newTag)
        this.paginaActual = 1
        this.cargarProductos()
      }
    },
    onProductosInCambia() {
      this.paginaActual = 1
      this.cargarProductos()
    },

    // ── CATEGORÍAS ────────────────────────────────────────────
    async cargarCategorias() {
      this.cargandoCategorias = true
      try {
        const { data } = await DynamicService.fetch(
          'cat', 'categoria', { quitar_paginacion: true }
        )
        this.categorias = data && data.results || data || []
      } catch {
        Notifications.alert.error('Error', 'No se pudieron cargar las categorías.')
      } finally {
        this.cargandoCategorias = false
      }
    },

    async onCategoriaCambia() {
      // Limpiar subcategoría y recargar
      this.subcategoriaId = ''
      this.subcategorias  = []
      this.paginaActual   = 1

      // Cargar subcategorías de la categoría seleccionada en paralelo con la tabla
      if (this.categoriaId !== '') {
        this.cargarSubcategorias(this.categoriaId)
      }
      this.cargarProductos()
    },

    async cargarSubcategorias(categoriaId) {
      this.cargandoSubcategorias = true
      try {
        const { data } = await DynamicService.fetch(
          'cat', 'subcategoria',
          { categoria: categoriaId, quitar_paginacion: true }
        )
        this.subcategorias = data && data.results || data || []
      } catch {
        Notifications.alert.error('Error', 'No se pudieron cargar las subcategorías.')
      } finally {
        this.cargandoSubcategorias = false
      }
    },

    onSubcategoriaCambia() {
      this.paginaActual = 1
      this.cargarProductos()
    },

    limpiarFiltroCategoria() {
      this.categoriaId    = ''
      this.subcategoriaId = ''
      this.subcategorias  = []
      this.paginaActual   = 1
      this.cargarProductos()
    },

    irAPagina(pagina) {
      const self = this
      if (pagina < 1 || pagina > this.totalPaginas || pagina === this.paginaActual) return
      if (this.editedCount > 0) {
        Notifications.alert.confirm(
          'Cambios sin guardar',
          'Tienes cambios sin guardar. Si cambias de página, se perderán. ¿Deseas continuar?',
          'Continuar',
          function() {
            self.paginaActual = pagina
            self.cargarProductos()
          }
        )
        return
      }
      this.paginaActual = pagina
      this.cargarProductos()
    },

    // ── GUARDAR ───────────────────────────────────────────────
    async guardarCambios() {
      if (!this.$refs.configTable) return
      
      const registros = this.$refs.configTable.getModifiedPayloads()
      if (!registros.length) return

      this.guardando = true

      try {
        const response = await DynamicService.postActionList(
          'cat',
          'producto-tienda',
          'updates_fields_or_creates_productotienda',
          { registros_modificados: registros }
        )
        const data = response.data
        const errors = data.errores && data.errores.length > 0
        const success = (data.actualizados && data.actualizados.length > 0) || (data.creados && data.creados.length > 0)
        if (errors) {
          this._manejarErroresGuardado({ response: { data } })
        }
        if (success) {
          if (errors) {
            const clavesErrores = data.errores.map(f => f.producto + '-' + f.tienda)
            this.$refs.configTable.resetSavedItemsExcluyendo(clavesErrores)
          } else {
            this.$refs.configTable.resetSavedItems()
          }
          if (errors) {
            Notifications.alert.warning(
              'Parcial',
              `Se guardaron ${data.actualizados.length} cambio(s), pero ${data.errores.length} no se pudieron actualizar.`
            )
          } else {
            Notifications.alert.success('Éxito', 'Cambios guardados exitosamente.')
          }
        } else if (!errors) {
          Notifications.alert.error(
            'Error',
            'Error al guardar. Intente nuevamente.'
          )
        }
      } catch (error) {
        this._manejarErroresGuardado(error)
        Notifications.alert.error(
          'Error',
          error.response && error.response.data && error.response.data.detail || 'Error al guardar. Intente nuevamente.'
        )
      } finally {
        this.guardando = false
      }
    },
    _manejarErroresGuardado(error) {
      const errores = (error && error.response && error.response.data && error.response.data.errores) || error.errores || []
      if (!errores.length) {
        Notifications.alert.error(
          'Error',
          error.response && error.response.data && error.response.data.detail || 'Error al guardar. Intente nuevamente.'
        )
        return
      }
      const erroresPorRegistro = {}
      let clavesCompletas = true
      errores.forEach(f => {
        if (f.producto && f.tienda) {
          erroresPorRegistro[`${f.producto}-${f.tienda}`] = f.error
        } else {
          clavesCompletas = false
        }
      })
       if (clavesCompletas) {
        this.$refs.configTable.marcarErroresInactivacion(erroresPorRegistro)
      } else {
        Notifications.alert.error(
          'Error',
          (error.response && error.response.data && error.response.data.detail) || 'Error al guardar. Intente nuevamente.'
        )
        return
      }
    },

    // ── HELPERS ───────────────────────────────────────────────
    iniciales(nombre) {
      return nombre.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase()
    },

// ── Métodos para que filtros sean adaptables a los datos cargados ───────────────────────────────
    _actualizarFiltrosDesdeProductos(items) {
      const abcFromData = Array.from(new Set(
        items
          .map(item => item.abc)
          .filter(value => value !== undefined && value !== null && value !== '')
      ))
      const abcValues = Array.from(new Set(['A', 'B', 'C', ...abcFromData])).sort()

      this.filtrosabc = [
        { valor: '', label: 'Todos' },
        ...abcValues.map(value => ({
          valor: value,
          label: value,
        }))
      ]

      const hasActive = items.some(item => item.activo === true)
      const hasInactive = items.some(item => item.activo === false)
      const estadoOptions = [{ valor: '', label: 'Todos' }]
      if (hasActive) {
        estadoOptions.push({ valor: 'activo', label: 'Activos' })
      }
      if (hasInactive) {
        estadoOptions.push({ valor: 'inactivo', label: 'Inactivos' })
      }
      this.filtrosEstado = estadoOptions

      if (this.filtroabc !== '' && !abcValues.includes(this.filtroabc)) {
        this.filtroabc = ''
      }
      if (this.filtroEstado !== '' && !estadoOptions.some(option => option.valor === this.filtroEstado)) {
        this.filtroEstado = ''
      }
    },
  },
}
</script>

